import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    success: {
        id: 'modal.details.modal.success',
        defaultMessage: 'Completed',
    },
    pending: {
        id: 'modal.details.modal.pending',
        defaultMessage: 'Pending',
    },
    error: {
        id: 'modal.details.modal.error',
        defaultMessage: 'Failed',
    },
    createdAt: {
        id: 'modal.details.modal.created_at',
        defaultMessage: 'Created at',
    },
    card: {
        id: 'modal.details.modal.card',
        defaultMessage: 'Card',
    },
    updatedAt: {
        id: 'modal.details.modal.updated_at',
        defaultMessage: 'Updated at',
    },
    transactionID: {
        id: 'modal.details.modal.transaction_id',
        defaultMessage: 'Transaction ID',
    },
    amount: {
        id: 'modal.details.modal.amount',
        defaultMessage: 'Amount',
    },
    merchant: {
        id: 'modal.details.modal.merchant',
        defaultMessage: 'Merchant',
    },
    merchantType: {
        id: 'modal.details.modal.merchant_type',
        defaultMessage: 'Merchant type',
    },
    status: {
        id: 'modal.details.modal.status',
        defaultMessage: 'Status',
    },
    expires: {
        id: 'modal.details.modal.expires',
        defaultMessage: 'Expires in {timeString}',
    },
    expired: {
        id: 'modal.details.modal.expired',
        defaultMessage: 'Expired',
    },
    alert: {
        id: 'modal.details.modal.alert',
        defaultMessage: 'Approval requires opening of mobile app.<br/>Tap Approve to continue.',
    },
    decline: {
        id: 'modal.details.modal.decline',
        defaultMessage: 'Decline',
    },
    approve: {
        id: 'modal.details.modal.approve',
        defaultMessage: 'Approve',
    },
    close: {
        id: 'modal.details.modal.close',
        defaultMessage: 'Close',
    },
    approveToast: {
        id: 'modal.details.modal.approve_toast',
        defaultMessage: 'Transaction approved',
    },
    rejectToast: {
        id: 'modal.details.modal.reject_toast',
        defaultMessage: 'Transaction rejected',
    },
})
